import {useApi} from "../Api";
import {SelectElementModelBE} from "../types/generic";

export const useCommercialSegmentRepository = () => {
    const {GET} = useApi();

    const PATH = "/pricing/commercial-segment";

    function getCommercialSegments(): Promise<SelectElementModelBE[]> {
        return GET(`${PATH}/list`);
    }

    return {getCommercialSegments};
};